import { LAUNCHER_ORIGIN } from '../config/endpoints.js';

/** Same pattern as Crown Crush `LauncherSession`: OTP against `launcher.<domain>/api`. */
const LAUNCHER_API = `${LAUNCHER_ORIGIN}/api`;

/**
 * Exchange a launcher OneTimeToken for a JWT access token.
 * @param {string} oneTimeToken
 * @returns {Promise<string>} accessToken
 */
export async function exchangeOneTimeToken(oneTimeToken) {
  const url = `${LAUNCHER_API}/token/otp?oneTimeToken=${encodeURIComponent(oneTimeToken)}`;
  const res = await fetch(url, { method: 'GET' });
  const bodyText = await res.text();
  console.log('[Launcher] /token/otp response status:', res.status, 'body:', bodyText);
  if (!res.ok) {
    throw new Error(`OTP exchange failed: ${res.status} ${res.statusText} — ${bodyText}`);
  }
  let parsed;
  try {
    parsed = JSON.parse(bodyText);
  } catch {
    throw new Error(`OTP response is not JSON: ${bodyText}`);
  }
  const src = parsed?.result ?? parsed?.Result ?? parsed;
  const accessToken = src?.accessToken ?? src?.AccessToken ?? src?.access_token;
  if (!accessToken) {
    throw new Error('Failed to exchange OneTimeToken for access token');
  }
  return accessToken;
}
